import { render, staticRenderFns } from "./BigQueryDatasets.vue?vue&type=template&id=e83c5caa"
import script from "./BigQueryDatasets.vue?vue&type=script&lang=ts"
export * from "./BigQueryDatasets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports